import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, Loader } from "semantic-ui-react";
import { getHomeProjectsInfolist } from "../../../api/BorrowerApi";
import { getMockHomeProjectsInfolist } from "../../../api/mock/MockBorrowerApi";
import { IProxyUser } from "../../interfaces/Global";
import BCEmptyState from "../../ui/BCEmptyState";
import "../../../styles/borrower/home.scss";
import BWProjectCard from "./BWProjectsCard";
import { FeatureFlags } from "../../constants/LocalServerConstants";

interface IBWProjectsContent {
  isApiMessage: string[];
  setIsApiMessage: React.Dispatch<React.SetStateAction<string[]>>;
  isGreaterThanTablet: boolean;
  proxyUser: IProxyUser | undefined;
  activeOnlyProjects: boolean;
}

const BWProjectsContent = ({
  isApiMessage,
  setIsApiMessage,
  isGreaterThanTablet, 
  proxyUser,
  activeOnlyProjects
} : IBWProjectsContent) => {
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [projectsInfoData, setProjectsInfoData] = useState(undefined as any);

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  useEffect(() => {
    const getProjectsInfoAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockHomeProjectsInfolist() : await getHomeProjectsInfolist(proxyUser && proxyUser.id);
        if (response && response.ok) {
          const projectsInfo = await response.json();
          setProjectsInfoData(projectsInfo);
        }
        else {
          FeatureFlags.IS_DEBUG && console.log("Projects response:");
          FeatureFlags.IS_DEBUG && console.log(response);
          setIsApiMessage([...isApiMessage, "Projects"]);
        }
      }
      catch (error) {
        handleError();
      }
      
      setIsLoading(false);
    };

    getProjectsInfoAsync();
  }, [handleError, proxyUser]);
    
  return (
    <React.Fragment>
      {isLoading ? <div className="borrower-home-loader"><Loader active inline="centered" size="big" /></div> : 
        <React.Fragment>
          {projectsInfoData && projectsInfoData.length > 0 ? <Card.Group itemsPerRow={isGreaterThanTablet ? 2 : 1}>
            {projectsInfoData.slice(0, 6).map((project, i) => <BWProjectCard project={project} index={i} key={"bw-project-card-" + i}/>)}
          </Card.Group> 
          : <BCEmptyState
              emptyStateClass="home-content-empty-state"
              icon="warehouse"
              text="You currently have no active project"
              content="Once a loan application is approved, it will appear as a project tile in this section"
            />
          }
        </React.Fragment>
      }
      {FeatureFlags.IS_DEBUG && <React.Fragment>
        <button onClick={() => console.log(projectsInfoData)}>projectsInfoData</button>
        <button onClick={() => console.log(activeOnlyProjects)}>activeOnlyProjects</button>
      </React.Fragment>}
    </React.Fragment>
  );
};

export default BWProjectsContent;